import {observable, action} from 'mobx'
import {api} from 'helpers/Api'
import {ICrudStore} from 'Store'
import {SettingsInvoice} from './Model'

export default class implements ICrudStore<SettingsInvoice> {
  @observable settingsInvoice: SettingsInvoice

  read() {
    return api.get('settings/invoice').then(this.set)
  }

  create(settingsInvoice: SettingsInvoice) {
    return api.post('settings/invoice', settingsInvoice).then(this.push)
  }

  update(id: number, settingsInvoice: SettingsInvoice) {
    return api.put('settings/invoice', settingsInvoice).then(this.set)
  }

  @action
  private set = (settingsInvoice: SettingsInvoice) => {
    this.settingsInvoice = new SettingsInvoice(settingsInvoice)
  };

  @action
  private push = (settingsInvoice: SettingsInvoice) => {
    this.settingsInvoice = new SettingsInvoice(settingsInvoice)
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/SettingsInvoice/Store.ts